<template>
<div class='dragTreeTableDiv'>
    <dragTreeTable :data="treeData" border :fixed="true" :height="tableHeight" :isdraggable="isdraggable" :onDrag="onTreeDataChange"></dragTreeTable>
</div>
</template>

<script>
  import dragTreeTable from 'drag-tree-table';
  export default {
      components: {
          dragTreeTable
      },
      data () {
          return {
              treeData: {
                  columns: this.treeColumns,
                  lists: this.treeDatas,
                  custom_field: {
                      id: 'id',
                      order: 'sort',
                      lists: 'children',
                      parent_id: 'pId'
                  }
              },
              expandAll: false
          };
      },
      props: {
          /* eslint-disable */
            treeDatas: {
                type: Array,
                default: () => []
            },
            treeColumns: {
                type: Array,
                default: () => []
            },
            isdraggable:{
                type: Boolean,
                default: false
            },
            tableHeight:{
                type: Number,
                default: 300
            },
            openLevel:{ // 树的子节点展开层级
                type: Number,
                default: 0
            }
        },
      methods: {
        async  _resetData(treeDatas){  
           for (let item of treeDatas) { 
              item.open=this.expandAll;
              if (item.children) {
                this.initPItem(item.children,item,true);
              }
            }
          this.treeData.lists = treeDatas;
        },
       async initPItem(treeDatas,parent,flg){
          for (let item of treeDatas) {
              item.open=this.expandAll;
              if(parent && flg){
                item.pItem=parent;
              }else{
                item.pItem=null;
              }
              if (item.children) {
                this.initPItem(item.children,item,flg);
              }
            }
        },
      async _submitData(treeDatas){  
          for (let item of treeDatas) {
            item.open=this.expandAll;
            item.pItem=null;
            if (item.children) {
             await this.initPItem(item.children,null,false);
            }
          }
          this.treeData.lists = treeDatas;
        },
        // list:更新后的数据源
        // from: 当前被拖拽的行
        // to: 目标拖拽行
        // where: 拖拽的类型，top（上面）、center（里面）、bottom（下面）
        async onTreeDataChange (list, from, to, where) {
            // console.log(from, to, where);
            this.treeData.lists = list;
            let order=0;
            for (let item of this.treeData.lists) {
              item.open=this.expandAll;
              item.viewOrder=++order;
              if (item.children) {
                this.setChildrenOrder(item.children, item.viewOrder);
              }
            }
            this.$emit('treeDataChange', this.treeData.lists);
        },
         setChildrenOrder (arr, order) {
              let innerOrder=0;
              arr.forEach((v, i) => {
                innerOrder++;
                v.open=this.expandAll;
                v.viewOrder=order*10+innerOrder;
                if (v.children) {
                    this.setChildrenOrder(v.children, v.viewOrder);
                }
              });
          },
        getCurrentTreeData(){
          return this.treeData.lists;
        },
        _resetExpandAll(flg){
          this.expandAll=flg;
        }
      }
};
</script>

<style  lang="less">
.dragTreeTableDiv {
  .drag-tree-table{
        // margin: 20px 0;
      margin: 0px;
      color: #606266;
      font-size: 12px;
    .drag-tree-table-header{
        display: flex;
        padding: 0px 10px;
        background: #f5f7fa;
        height: 36px;
        line-height: 36px;
        box-sizing: border-box;
        font-weight: 600;
        .tree-column {
          padding: 0 4px; 
          min-width: 60px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .drag-tree-table-body{
        .tree-column {
          padding: 0 4px; 
          min-width: 60px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
  }
  
  .tree-row{
    position: relative;
    display: flex;
    padding:  5px 10px;//10px
    border-bottom: 1px solid #eee;
    line-height: 32px;
  }
  
}

</style>


// WEBPACK FOOTER //
// src/components/TreeTableDrag/TreeTableDrag.vue